import { zodResolver } from "@hookform/resolvers/zod";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
	Textarea,
} from "@monbits/ui";
import type * as React from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

interface Props {
	onFinish: (
		values: { topic: string; message: string },
		reset: () => void,
	) => Promise<void>;
	isFormSubmitting: boolean;
}

const formSchema = z.object({
	topic: z.string().min(1, "Field is required"),
	message: z.string().min(1, "Field is required"),
});

type FormValues = z.infer<typeof formSchema>;

const SupportForm: React.FC<Props> = (props: Props) => {
	const form = useForm<FormValues>({
		resolver: zodResolver(formSchema),
		defaultValues: {
			topic: "Support",
			message: "",
		},
	});

	const onSubmit = async (values: FormValues) => {
		await props.onFinish(values, form.reset);
	};

	return (
		<Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
				<FormField
					control={form.control}
					name="topic"
					render={({ field }) => (
						<FormItem>
							<FormLabel>Topic</FormLabel>
							<Select onValueChange={field.onChange} defaultValue={field.value}>
								<FormControl>
									<SelectTrigger className="w-[150px]">
										<SelectValue placeholder="Select topic" />
									</SelectTrigger>
								</FormControl>
								<SelectContent>
									<SelectItem value="Support">Support</SelectItem>
									<SelectItem value="Feedback">Feedback</SelectItem>
								</SelectContent>
							</Select>
							<FormMessage />
						</FormItem>
					)}
				/>
				<FormField
					control={form.control}
					name="message"
					render={({ field }) => (
						<FormItem>
							<FormLabel>Message</FormLabel>
							<FormControl>
								<Textarea
									placeholder="Type your message here..."
									className="resize-none min-h-[100px]"
									rows={4}
									{...field}
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
			</form>
		</Form>
	);
};

export default SupportForm;
